function isRealPitch(pitch) {
    return !['UN', 'IN', 'AB', 'AS', 'NP', ''].includes(pitch)
}

export default function PopulateSettings(data, chart) {
    // DEFAULT SCALE SETTINGS = SQUARE (Instagram)
    let svgWidth = 500
    let svgHeight = 500
    let margin = {
        top: svgWidth * 0.18,
        right: svgWidth * 0.28,
        bottom: svgWidth * 0.08,
        left: svgWidth * 0.04,
    }
    let vizScale = 0.65
    let vizPadding = {
        top: svgWidth * 0.35,
        left: svgWidth * 0.2,
    }
    let orientation = 'landscape'

    if (chart.shape === 'square') {
        svgWidth = 500
        svgHeight = 500
        margin = {
            top: svgWidth * 0.18,
            right: svgWidth * 0.28,
            bottom: svgWidth * 0.08,
            left: svgWidth * 0.04,
        }
        vizScale = 0.65
        vizPadding = {
            top: svgWidth * 0.35,
            left: svgWidth * 0.2,
        }

        // try to auto determine padding.... buggy
        if (
            chart.vizScaleOverride &&
            !chart.vizScaleOverrideTop &&
            !chart.vizScaleOverrideLeft
        ) {
            vizPadding = {
                top:
                    svgWidth / 2 / chart.vizScaleOverride -
                    (svgWidth * chart.vizScaleOverride) / 2,
                left:
                    svgWidth / 2 / chart.vizScaleOverride -
                    (svgWidth * chart.vizScaleOverride) / 2,
            }
        }
        // Manual override of padding
        else if (
            chart.vizScaleOverride &&
            chart.vizScaleOverrideTop &&
            chart.vizScaleOverrideLeft
        ) {
            vizPadding = {
                top: chart.vizScaleOverrideTop,
                left: chart.vizScaleOverrideLeft,
            }
        }

        if (chart.chartType === 'sideways') {
            vizPadding = {
                top: svgWidth * 0.45,
                left: svgWidth * 0.05,
            }
        }
        if (chart.chartType === 'line') {
            vizPadding = {
                top: svgWidth * 0.3,
                left: svgWidth * 0.2,
            }
        }
    }
    if (chart.shape === 'twitter') {
        svgWidth = 640
        svgHeight = 360
        margin = {
            top: svgHeight * 0.225,
            right: svgWidth * 0.3,
            bottom: svgHeight * 0.09,
            left: svgWidth * 0.2,
        }
        vizScale = 0.46
        vizPadding = {
            top: svgHeight * 0.58,
            left: svgWidth * 0.5,
        }
        if (chart.chartType === 'sideways') {
            vizScale = 0.65
            vizPadding = {
                top: svgWidth * 0.18,
                left: svgWidth * 0.125,
            }
        }
        if (chart.chartType === 'line') {
            vizPadding = {
                top: svgWidth * 0.28,
                left: svgWidth * 0.65,
            }
        }
    }

    if (chart.shape === 'snap') {
        svgWidth = 360
        svgHeight = 640
        margin = {
            top: svgHeight * 0.15,
            right: svgWidth * 0.1,
            bottom: svgHeight * 0.08,
            left: svgWidth * 0.0,
        }
        vizScale = 0.6
        vizPadding = {
            top: svgHeight * 0.4,
            left: svgWidth * 0.1,
        }
        orientation = 'portrait'

        if (chart.chartType === 'sideways') {
            vizScale = 0.48
            vizPadding = {
                top: svgWidth * 0.9,
                left: svgWidth * 0.05,
            }
        }
        if (chart.chartType === 'line') {
            vizScale = 0.6
            vizPadding = {
                top: svgWidth * 0.7,
                left: svgWidth * 0.3,
            }
        }
    }

    // Scale for g
    const VIZ_WIDTH = 500
    const VIZ_HEIGHT = 500

    const shapeRatio = chart.shapeRatio || 1

    const firstFieldType = chart.charts.findIndex(
        (c) => c.chartType === 'field'
    )

    const charts = chart.charts.map((d, i) => ({
        ...d,
        index: i,
        showField: i <= firstFieldType,
    }))

    const settings = {
        data: Array.isArray(data)
            ? data.filter(
                  (d) =>
                      typeof d.pitchType !== 'string' ||
                      isRealPitch(d.pitchType)
              )
            : data,
        //    chartType: chart.chartType || "pitch",
        charts,
        shape: chart.shape || 'square',
        vizWidth: VIZ_WIDTH || 500,
        vizHeight: VIZ_HEIGHT || 500,
        svgWidth,
        svgHeight,
        ratioWidth: svgWidth * shapeRatio,
        ratioHeight: svgHeight * shapeRatio,
        venueId: chart.venueId || 7,
        margin: margin || { top: 0, left: 0, bottom: 0, right: 0 },
        vizPadding: vizPadding || { top: 0, left: 0 },
        vizScale: vizScale || 0.65,
        vizScaleOverride: chart.vizScaleOverride || 0,
        orientation: orientation || 'landscape',
        lineGraphChart: chart.lineGraphChart || { show: false },
        namePlate: chart.namePlate || { show: false },
        sourcePlate: chart.sourcePlate || { show: false },
        mainPanelBackground: chart.mainPanelBackground || '#fff',
        mainPanelStroke: chart.mainPanelStroke || '#c2c2c2',
        svgZoom: chart.svgZoom || null,
        enableZoom: Boolean(chart.enableZoom),
    }

    settings.width = svgWidth - settings.margin.left - settings.margin.right
    settings.height = svgHeight - settings.margin.top - settings.margin.bottom

    return settings
}
